export const SearchAddOn_ByTag = {
    key: 'tag-filter',
    methodName: 'getTagGroups',
    label: 'Tags',
    group: 'Properties',
    isActive: (param) => !!param?.include.length || !!param?.exclude.length,
    resultFilter: (value, result) => {
        const tagGroups = result.filterResults['tag-filter'].value;
        // Flatten every present childId into a single Set for O(1) lookups
        const presentChildIds = new Set();
        for (const group of tagGroups)
            for (const childId of group.value)
                presentChildIds.add(childId);
        // Fail if any include childId is missing
        if (value.include?.some(filter => !presentChildIds.has(filter.childId)))
            return { pass: false };
        // Fail if any exclude childId is present
        if (value.exclude?.some(filter => presentChildIds.has(filter.childId)))
            return { pass: false };
        return { pass: true };
    }
};
//# sourceMappingURL=types.js.map